import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DynamicInput from "react-dynamic-input"
import { Modal } from 'react-bootstrap';
import axiosInstance from '../../../../services/AxiosInstance';
import swal from 'sweetalert';
import InputField from '../../../../components/InputField';
import GoBackButton from '../../../../components/GoBackButton';

const Dashboard = () => {

    const [input, setInput] = useState([{ name: "" }]);
    const [data, setData] = useState([]);
    const [datas, setDatas] = useState({});
    const [modal, setModal] = useState(false);
    var min_data = Object.values(input[0]);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        axiosInstance(
            "interview-workflow/", {
            method: "GET",
            data: {}
        }).then(res => {
            setData(res?.data?.results);
        })
    }

    const handleEdit = (id) => {
        axiosInstance(
            `interview-workflow/${id}`, {
            method: "GET",
            data: {}
        }).then(res => {
            setDatas(res?.data);
            var edata = []
            // eslint-disable-next-line
            var te = Object.values(res?.data.workflow).forEach((rest, i) => {
                edata.push({
                    name: rest,
                })
            })
            setInput(edata);
        })
        setModal(true);
    }

    const handleSubmit = () => {
        const d = []
        input.forEach(res => {
            d.push(res.name);
        })
        if (d.includes("")) {
            setModal(false);
            swal({
                text: "Please fill all the fields",
                icon: "error",
                dangerMode: true,
            }).then(willDelete => {
                if (willDelete) {
                    setModal(true);
                }
            });
        } else if (min_data[0] !== "") {
            var wf = {}
            // eslint-disable-next-line
            var t = input?.map((res, i) => {
                wf[`step${i + 1}`] = res.name;
            })
            var postData = {
                name: datas?.name,
                workflow: wf
            }
            var url = datas?.id ? `interview-workflow/${datas?.id}/` : "interview-workflow/";
            var method = datas?.id ? "PUT" : "POST";
            axiosInstance(
                url, {
                method: method,
                data: postData
            }).then(res => {
                setModal(false);
                swal("", "Workflow added successfully", "success", { button: "Ok" });
                getData();
                setInput([{ name: "" }]);
                setDatas({});
            }).catch(err => {
                setModal(false);
                swal("", (err.response.data.detail), "error", { button: "Ok" });
            })
        }
    }

    const handleDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete this record?",
            icon: "warning",
            dangerMode: true,
        }).then(willDelete => {
            if (willDelete) {
                axiosInstance(`interview-workflow/?delete_ids=${id}`, { method: "DELETE" })
                    .then(res => {
                        if (res?.status === 204) {
                            getData();
                            swal("", "Deleted Successfully", "success", { button: "Ok!", })
                        }
                    })
                    .catch(err => swal("", err?.response?.data?.detail, { button: "Ok!", }))
            }
        });
    }

    const handleClose = () => {
        setModal(false);
        setInput([{ name: "" }]);
    }

    return (
        <>
            <div className="job-bx submit-resume">
                <div className="job-bx-title clearfix">
                    <h5 className="font-weight-700 pull-left text-uppercase">Workflow</h5>
                    <GoBackButton />
                </div>
                <div>
                    <div className="float-right">
                        <button
                            className="btn btn-primary ml-3 mb-3"
                            onClick={() => {
                                setModal(true); setInput([{}]);
                                setDatas({});
                            }}
                        >
                            Add
                        </button>
                    </div>
                    <div className="table-resposive template-table">
                        <table className="table-job-bx cv-manager company-manage-job">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data?.length > 0 ? data?.map((res, i) => {
                                        return (
                                            <tr key={res?.name}>
                                                <td>{i + 1}</td>
                                                <td>{res?.name}</td>
                                                <td className="job-links pr-0" key="viewicon" style={{ display: "flow-root" }}>
                                                    <Link to={"#"} onClick={() => handleEdit(res.id)}>
                                                        <i className="ti-pencil" title="Click here to Edit the Data" />
                                                    </Link>
                                                    <span onClick={() => handleDelete(res.id)}>
                                                        <i className="ti-trash" title='Click here to delete the record' style={{ cursor: "pointer" }} />
                                                    </span>
                                                </td>
                                            </tr>
                                        )
                                    })
                                        :
                                        <tr>
                                            <td colSpan="3">
                                                <div className="alert alert-danger">
                                                    <h5 className="text-center">No Data Found</h5>
                                                </div>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal className="modal fade browse-job modal-bx-info editor" size="lg" show={modal} onHide={() => setModal(false)}>
                <div className="my-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="ProfilenameModalLongTitle">Add Workflow</h5>
                            <button type="button" className="close" onClick={() => setModal(false)}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <InputField
                                name="name"
                                label="Name"
                                value={datas?.name}
                                onChange={(e) => setDatas({ ...datas, name: e.target.value })}
                                required={true}
                                placeholder="Enter name"
                            />
                            <label>Workflow</label>
                            {input.map((item, index) => (
                                <p key={(index + 1) * 2}>Step {index + 1}:{item.name}</p>
                            ))}
                            <DynamicInput
                                inputName="name"
                                addButtonText="Add Next Step"
                                setInput={setInput}
                                input={input}
                                onSubmit={handleSubmit}
                                submitButtonText="Submit"
                                addPosition="bottom"
                                required={true}
                                type="text"
                                toolTip={true}
                                toolTipText="Add Next Step"
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="site-button" onClick={() => handleClose()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Dashboard;